import {Menu, MenuItem} from '@/components/ui/menu-atoms/MenuAtoms'
import styled, {css} from 'styled-components'

export const StyledAccountMenu = styled(Menu)(
    ({theme: {palette, shadows, typography}}) => css`
        background-color: ${palette.neutral.white};
        border-radius: 8px;
        box-shadow: ${shadows.md};
        overflow: hidden;
        width: 280px;
        font-weight: 500;
        color: ${palette.neutral[700]};
        ${typography.textSm};
    `
)

export const StyledMenuItem = styled(MenuItem)(
    ({theme: {spacing, typography, palette}}) => css`
        padding: ${spacing * 2.5}px ${spacing * 3}px;
        min-height: 32px;
        font-weight: 400;
        font-size: ${typography.textSm};
        transition: ease-in-out 200ms;
        color: ${palette.neutral.black};
        &:hover {
            background: ${palette.neutral['100']};
            cursor: pointer;
        }
    `
)
